
export default {
  name: 'BlocksAuthorBlock',

  computed: {
    authorData() {
      const node = this.$store.state.pages.page?.author?.node
      if (!node) return null
      return {
        ...node,
        avatar: node.avatar ? { url: decodeURIComponent(node.avatar.url) } : null,
      }
    },
  },
}
